module.exports = __webpack_public_path__ + "static/media/logo_login.29f2f954.png";